import api from '../api/api';

/**
 * Get performance insights for a halaqa (class)
 * @param {string} halaqaId - Halaqa ID
 * @param {number} days - Number of days to analyze (default: 7)
 * @returns {Promise} Promise resolving to insights data
 */
export const getHalaqaInsights = async (halaqaId, days = 7) => {
  try {
    console.log(`Fetching insights for halaqa ${halaqaId} (${days} days)`);
    const params = { days };
    const response = await api.get(`/insights/performance/halaqa/${halaqaId}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching halaqa insights:', error);
    throw error.response ? error.response.data : new Error('Network error');
  }
};

/**
 * Get available insights for the authenticated user
 * @returns {Promise} Promise resolving to available insights list
 */
export const getAvailableInsights = async () => {
  try {
    console.log('Fetching available insights for user');
    const response = await api.get('/insights/available');
    return response.data;
  } catch (error) {
    console.error('Error fetching available insights:', error);
    throw error.response ? error.response.data : new Error('Network error');
  }
};

/**
 * Future implementation - Student insights for parents
 * @param {string} studentId - Student ID
 * @param {number} days - Number of days to analyze (default: 7)
 * @returns {Promise} Promise resolving to student insights
 */
export const getStudentInsights = async (studentId, days = 7) => {
  try {
    console.log(`Fetching insights for student ${studentId} (${days} days)`);
    const params = { days };
    const response = await api.get(`/insights/performance/student/${studentId}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching student insights:', error);
    throw error.response ? error.response.data : new Error('Network error');
  }
};

/**
 * Get attendance-performance correlation insights for a halaqa
 * Demo July 2025 v1.0 feature
 * @param {string} halaqaId - Halaqa ID
 * @param {number} days - Number of days to analyze (default: 30)
 * @returns {Promise} Promise resolving to correlation data
 */
export const getAttendancePerformanceCorrelation = async (halaqaId, days = 30) => {
  try {
    console.log(`Fetching attendance-performance correlation for halaqa ${halaqaId} (${days} days)`);
    const params = { days };
    const response = await api.get(`/insights/correlation/attendance-performance/${halaqaId}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching attendance-performance correlation:', error);
    throw error.response ? error.response.data : new Error('Network error');
  }
};

/**
 * Future implementation - Center insights for admins
 * @param {string} centerId - Center ID
 * @param {number} days - Number of days to analyze (default: 7)
 * @returns {Promise} Promise resolving to center insights
 */
export const getCenterInsights = async (centerId, days = 7) => {
  try {
    console.log(`Fetching insights for center ${centerId} (${days} days)`);
    const params = { days };
    const response = await api.get(`/insights/performance/center/${centerId}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching center insights:', error);
    throw error.response ? error.response.data : new Error('Network error');
  }
};